import React, { useState } from 'react';
import { Dialog, MenuItem, Paper } from "@mui/material";
import Draggable from "react-draggable";
import { CloseOutlined, DragIndicatorOutlined } from "@mui/icons-material";
import { NotesView } from "~/components/patientReports/PastNotes/NotesView";
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
// Draggable modal for past notes
function PaperComponent(props) {
    return (React.createElement(Draggable, { handle: "#draggable-icon", cancel: '[class*="MuiDialogContent-root"]', bounds: 'parent' },
        React.createElement(Paper, { style: { maxWidth: '700px' }, ...props })));
}
export const PastNotes = (props) => {
    const { patient, notes, onClose, reportClicked, isReportOpen } = props;
    const [filteredNotes, setFilteredNotes] = useState(notes);
    const [selectedFilter, setSelectedFilter] = useState('most-recent');
    console.log(patient);
    const filterNotes = (filterValue) => {
        console.log(filterValue);
        setSelectedFilter(filterValue);
        if (filterValue === 'confirm-analysis') {
            const confirmNotes = notes.filter((row) => row.is_confirm_analysis);
            // @ts-ignore
            setFilteredNotes(confirmNotes);
        }
        if (filterValue === 'add-time') {
            const addTimeNotes = notes.filter((row) => !row.is_confirm_analysis);
            // @ts-ignore
            setFilteredNotes(addTimeNotes);
        }
        if (filterValue === 'most-recent') {
            setFilteredNotes(notes);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Dialog, { hideBackdrop: true, open: true, onClose: onClose, PaperComponent: PaperComponent, disableEnforceFocus: true, style: { pointerEvents: 'none', marginRight: isReportOpen ? 'auto' : 'inherit' }, PaperProps: { style: { pointerEvents: 'auto', maxWidth: '700px', marginRight: isReportOpen ? 'auto' : 'inherit' } } },
            React.createElement("div", { style: { height: '100%', width: '675px' } },
                React.createElement("div", { className: 'flex p-2 items-center' },
                    React.createElement(DragIndicatorOutlined, { style: { cursor: 'move' }, id: 'draggable-icon' }),
                    React.createElement("div", { style: { fontFamily: 'Barlow', fontWeight: 400, width: '150px' } }, "Past Notes"),
                    React.createElement(FormControl, { fullWidth: true },
                        React.createElement(InputLabel, { id: "demo-simple-select-label" }, "Filter"),
                        React.createElement(Select, { size: 'small', style: { width: 200 }, labelId: "demo-simple-select-label", id: "demo-simple-select", value: selectedFilter, label: "Filter", onChange: (val) => filterNotes(val.target.value) },
                            React.createElement(MenuItem, { value: 'most-recent' }, "Most Recent"),
                            React.createElement(MenuItem, { value: 'confirm-analysis' }, "Data Analysis"),
                            React.createElement(MenuItem, { value: 'add-time' }, "Other"))),
                    React.createElement(CloseOutlined, { style: { marginLeft: 'auto', float: 'right', cursor: 'pointer' }, onClick: onClose })),
                React.createElement("div", null, filteredNotes.map((note) => React.createElement("div", { className: 'p-5', style: { height: 300 } },
                    React.createElement(NotesView, { note: note, viewReportClicked: (reportId) => reportClicked(reportId) }))))))));
};
